import { render, staticRenderFns } from "./TrancheDealStructure.vue?vue&type=template&id=3ca09bda&"
import script from "./TrancheDealStructure.vue?vue&type=script&lang=js&"
export * from "./TrancheDealStructure.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports